export default __webpack_public_path__ + "a8e750765af649aac2e0ec51e9e8d345.png";